module.exports = __webpack_public_path__ + "img/tutors-posts.12e223af.jpeg";